"use strict";
// This function converts a 24-hour time format to a 12-hour time format with AM or PM. 
// Also if passed valued is already in 12 Hour format with AM PM then it just returns it as is 
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTo12Hour = convertTo12Hour;
function convertTo12Hour(time24) {
    // Check if the input is already in the expected format
    if (/^\d{1,2}:\d{2} [APM]{2}$/i.test(time24)) {
        return time24.toUpperCase();
    }
    var _a = time24.split(':').map(Number), hours = _a[0], minutes = _a[1];
    if (hours >= 0 && hours <= 11) {
        // Convert to 12-hour format with "AM"
        var amTime = "".concat(hours === 0 ? 12 : hours, ":").concat(minutes.toString().padStart(2, '0'), " AM");
        return amTime.toUpperCase();
    }
    else if (hours >= 12 && hours <= 23) {
        // Convert to 12-hour format with "PM"
        var pmTime = "".concat(hours === 12 ? 12 : hours - 12, ":").concat(minutes.toString().padStart(2, '0'), " PM");
        return pmTime.toUpperCase();
    }
    else {
        // Handle invalid input
        return 'Invalid Time';
    }
}
